export default __webpack_public_path__ + "static/media/no_image.1a2d0029.png";